var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-dashboard"},[_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"welcome-box"},[_c('h1',[_vm._v("Welcome")]),_c('p',[_vm._v("to Partner Dashboard!")])])])])
}]

export { render, staticRenderFns }